import initSettingModal from '../modal.js'

$(document).on('turbolinks:load', () => {
  initModal()
  initSettingBrandsPage()
})

const initModal = () => {
  const {
    onClickOpenCreateModal,
    onClickOpenEditModals,
    onClickOpenDeleteModals,
    onClickCloseModal,
    onClickCloseDeleteModal,
  } = initSettingModal({target: 'brand'})

  onClickOpenCreateModal()
  onClickOpenEditModals()
  onClickOpenDeleteModals()
  onClickCloseModal()
  onClickCloseDeleteModal()
}

const initSettingBrandsPage = () => {
  onDragAndDropBrandImage()
  onChangeBrandImage()
}

const onDragAndDropBrandImage = () => {
  const selector = $('.brand-image')
  selector.on('dragover', (event) => event.preventDefault())
  selector.on('drop', (event) => {
    event.preventDefault()
    const files = event.originalEvent.dataTransfer.files
    if ((files.length === 1) && /image\/(jpeg|png)/.test(files[0].type)) {
      const area = $(event.currentTarget)
      const input = area.find('input[name="brand[image]"]')
      input.data('file', files[0])
      input.val(null)
      changeBrandBackgroundImage(area, files[0])
    }
  })
  selector.closest('form').on('ajax:beforeSend', (event) => {
    const file = $(event.target).find('input[name="brand[image]"]').data('file')
    if (file) {
      event.originalEvent.detail[1].data.append('brand[image]', file)
    }
  })
}

const onChangeBrandImage = () => {
  $('.brand-image input[name="brand[image]"]').on('change', (event) => {
    const file = event.target.files[0]
    if (!file) {
      return
    }
    const input = $(event.target)
    input.removeData('file')
    changeBrandBackgroundImage(input.closest('.brand-image'), file)
  })
}

const changeBrandBackgroundImage = (area, file) => {
  const reader = new FileReader()
  reader.onload = (event) => {
    area.css('background-image', 'url(' + event.target.result + ')')
  }
  reader.readAsDataURL(file)
}
